module.exports = __webpack_public_path__ + "static/media/studio3-3.39af85b2.png";